import { Directive, effect, inject } from '@angular/core';

import { SvgIconComponent } from 'angular-svg-icon';

import { generateUniqueIds } from './svg-unique-ids';

/**
 * Attaches to every `svg-icon` and rewrites the internal ids of the inlined
 * svg (and the `url(#id)` references to them) to be unique per
 * instance. Without this, icons sharing ids resolve their references to the
 * first matching element in the document, making icons render wrong or
 * disappear (VPL-48241). Runs after every (re)load via the component's public
 * `svg` version signal.
 */
@Directive({
	selector: 'svg-icon',
})
export class SvgUniqueIdsDirective {
	private readonly icon = inject(SvgIconComponent);

	constructor() {
		effect(() => {
			if (this.icon.svg()) {
				generateUniqueIds(this.icon.elemSvg as SVGElement);
			}
		});
	}
}

export const SVG_ICON_IMPORTS = [SvgIconComponent, SvgUniqueIdsDirective];
